<template lang='pug'>
  v-card( v-bind='cardProps' )
    v-card-title( v-bind='titleProps' ) {{ title }}
</template>

<script>
  export default {
    props: {
      cardProps: {
        type: Object,
        default: () => ({
          class: 'elevation-0 mb-3 px-2',
          color: 'primary',
          dark: true,          
        }),        
      },
      title: {
        type: String,
        default: 'primary',
      },
      titleProps: {
        type: Object,
        default: () => ({
          class: 'subheading font-weight-medium',          
        }),
      },
    },
  }
</script>